import React from 'react';
import "./Loading.css"
const HomeLoading = () => {
    return (
        <div className='body'>
            <h1 data-text="Loading..." className='h1'>Loading....</h1>
        </div>
    );
};

export default HomeLoading;